import React from "react";
import { useFirebase } from "../Firebase";
import { LogOutStyle } from "./style";
import { LogOutCircle } from "@styled-icons/boxicons-regular/LogOutCircle";

const SignOutButton = ({ navigate }) => {
  const firebase = useFirebase();

  return (
    <LogOutStyle onClick={() => firebase.signOut(navigate)}>
      <LogOutCircle />
      <p>Sign out</p>
    </LogOutStyle>
  );
};

export default SignOutButton;
